import { useTranslation } from 'react-i18next';

export default function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:rounded-full focus:bg-ink focus:px-4 focus:py-2.5 focus:text-sm focus:font-medium focus:text-surface focus:no-underline focus:shadow-lg"
    >
      {t('a11y.skipToContent')}
    </a>
  );
}
